/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './entity-table.scss';

/*@ngInject*/
export function EntityTableController($rootScope, $sce, $scope, $mdMedia, $mdDialog, $document, $state, $window,
                                              $stateParams, $q, $translate, $filter, types, entityTableConfiguration, userService) {

    var vm = this;

    vm.$onInit = function () {
        vm.initialEntityId = $stateParams.entityId;

        vm.types = types;
        vm.grafanaEnabled = $window.DynamicConfigs.grafanaEnabled === 'true';

        vm.isAdminAuthority = () => {
            const authority = userService.getAuthority();
            return types.adminAuthorities.includes(authority);
        }

        vm.entityTableConfiguration = entityTableConfiguration;

        vm.actionCellDescriptors = angular.copy(vm.entityTableConfiguration.actionCellDescriptors);
        vm.actionCellDescriptors.push(
            {
                name: 'action.delete',
                icon: 'delete',
                isEnabled: (entity) => {
                    return vm.entityTableConfiguration.deleteEnabled(entity);
                },
                onAction: ($event, entity) => {
                    deleteEntity($event, entity);
                }
            }
        );

        vm.groupActionMenuDescriptors = angular.copy(vm.entityTableConfiguration.groupActionMenuDescriptors);
        vm.groupActionDescriptors = angular.copy(vm.entityTableConfiguration.groupActionDescriptors);
        vm.groupActionDescriptors.push(
            {
                name: 'action.delete',
                icon: 'delete',
                isEnabled: () => {
                    return vm.entityTableConfiguration.entitiesDeleteEnabled();
                },
                onAction: ($event, entities) => {
                    deleteEntities($event, entities);
                }
            }
        );

        vm.entityTableConfiguration.reloadEntities = (reloadDetails) => {
            reloadEntities(reloadDetails)
        };

        vm.shouldOverlay = function () {
            return $rootScope.shouldOverlay;
        };

        vm.entityType = vm.entityTableConfiguration.entityType;
        vm.columns = vm.entityTableConfiguration.columns;
        vm.translations = vm.types.entityTypeTranslations[vm.entityType];

        vm.entities = [];
        vm.selectedEntities = [];
        vm.entitiesCount = 0;

        vm.allEntities = [];

        vm.currentEntity = null;
        vm.isDetailsOpen = false;

        vm.displayPagination = true;
        vm.serverPagedData = vm.entityTableConfiguration.serverPagedData;
        vm.defaultPageSize = 10;
        vm.defaultSortOrder = '-' + types.entityTable.entityField.createdTime.value;

        for (var i = 0; i < vm.columns.length; i++) {
            var column = vm.columns[i];
            if (column.sortOrder && column.sortOrder !== types.entityTable.sortOrder.none.value) {
                if (column.sortOrder == types.entityTable.sortOrder.desc.value) {
                    vm.defaultSortOrder = '-' + (column.sortKey || column.key);
                } else {
                    vm.defaultSortOrder = (column.sortKey || column.key);
                }
                break;
            }
        }

        vm.query = {
            order: vm.defaultSortOrder,
            limit: vm.defaultPageSize,
            page: 1,
            search: null,
            isFrontEndSort: function() {
                return $filter('filter')(vm.columns, {sortType: types.entityTable.sortType.frontEnd.value}, true)
                    .some((res) => this.order.endsWith(res.sortKey));
            }
        };

        vm.addEntity = addEntity;
        vm.openBulkProvisioning = openBulkProvisioning;
        vm.openAssigning = openAssigning;
        vm.openDashboard = openDashboard;
        vm.enterFilterMode = enterFilterMode;
        vm.exitFilterMode = exitFilterMode;
        vm.onReorder = onReorder;
        vm.onPaginate = onPaginate;
        vm.onRowClick = onRowClick;

        vm.isCurrent = isCurrent;

        vm.cellStyle = cellStyle;
        vm.cellContent = cellContent;

        vm.onEntityUpdated = onEntityUpdated;
        vm.deleteEntity = deleteEntity;

        reloadEntities(false, vm.initialEntityId);
        vm.initialEntityId = null;
    };

    $scope.$watch("vm.query.search", function(newVal, prevVal) {
        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
            if (vm.serverPagedData) {
                reloadEntities()
            } else {
                updateEntities();
            }
        }
    });

    $scope.$watch(function() { return $mdMedia('gt-xs'); }, function(isGtXs) {
        vm.isGtXs = isGtXs;
    });

    $scope.$watch(function() { return $mdMedia('gt-md'); }, function(isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [vm.defaultPageSize, vm.defaultPageSize*2, vm.defaultPageSize*3];
        } else {
            vm.limitOptions = null;
        }
    });

    $scope.$on('$destroy', function () {
        vm.entityTableConfiguration.onDestroy();
    });

    $scope.$on('entityUpdated', function (event, entity) {
        if (entity && entity.id) {
            onEntityUpdated(entity);
        }
    });

    function enterFilterMode () {
        vm.query.search = '';
    }

    function exitFilterMode () {
        vm.query.search = null;
        if (vm.serverPagedData) {
            reloadEntities()
        } else {
            updateEntities();
        }
    }

    function onReorder () {
        if (vm.serverPagedData && !vm.query.isFrontEndSort()) {
            reloadEntities()
        } else {
            updateEntities();
        }
    }

    function onPaginate () {
        if (vm.serverPagedData) {
            reloadEntities()
        } else {
            updateEntities();
        }
    }

    function onRowClick($event, entity) {
        if ($event) {
            $event.stopPropagation();
        }
        if (vm.currentEntity != entity) {
            vm.currentEntity = entity;
            vm.isDetailsOpen = true;
        } else {
            vm.isDetailsOpen = !vm.isDetailsOpen;
        }
    }

    function openEntityDetails(entityId) {
        if (entityId && entityId.id) {
            var result = $filter('filter')(vm.allEntities, {id: {id: entityId.id} }, true);
            if (result && result.length) {
                var entity = result[0];
                vm.currentEntity = entity;
                vm.isDetailsOpen = true;
            }
        }
    }

    function isCurrent(entity) {
        return (vm.currentEntity && entity && vm.currentEntity.id && entity.id) &&
            (vm.currentEntity.id.id === entity.id.id);
    }

    function reloadEntities(reloadDetails, initialEntityId) {
        vm.isDetailsOpen = false;
        vm.allEntities = [];
        vm.selectedEntities = [];
        vm.entityTableConfiguration.loadEntities($scope).then(
            function success(entities) {
                if (vm.serverPagedData) {
                    vm.entitiesCount = entities.totalElements;
                    vm.allEntities = entities.data;
                } else {
                    vm.allEntities = entities;
                }
                updateEntities(reloadDetails, initialEntityId);
            },
            function fail() {}
        );
    }

    function addEntity($event) {
        $mdDialog.show({
            controller: vm.entityTableConfiguration.addEntityController,
            controllerAs: 'vm',
            templateUrl: vm.entityTableConfiguration.addEntityTemplateUrl,
            parent: angular.element($document[0].body),
            locals: {entityTableConfiguration: vm.entityTableConfiguration},
            fullscreen: true,
            skipHide: true,
            targetEvent: $event
        }).then(function () {
            entityAdded();
        }, function () {
        });
    }

    function openBulkProvisioning($event) {
        $mdDialog.show({
            controller: vm.entityTableConfiguration.bulkProvisioningController,
            controllerAs: 'vm',
            templateUrl: vm.entityTableConfiguration.bulkProvisioningTemplate,
            parent: angular.element($document[0].body),
            locals: {
                entityTableConfiguration: vm.entityTableConfiguration
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event
        }).then(
            function () {
            },
            function () {
            });
    }

    function openDashboard($event) {
        if ($event) {
            $event.stopPropagation();
        }
        if ($stateParams.gatewayGroupId) {
            $state.go('home.gatewayGroups.gateways.dashboard', {gatewayGroupId: $stateParams.gatewayGroupId});
        } else {
            $state.go('home.gateways.dashboard');
        }        
    }

    function openAssigning($event) {
        $mdDialog.show({
            controller: vm.entityTableConfiguration.assignEntityController,
            controllerAs: 'vm',
            templateUrl: vm.entityTableConfiguration.assignEntityTemplate,
            parent: angular.element($document[0].body),
            locals: {
                entityTableConfiguration: vm.entityTableConfiguration
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event
        }).then(
            function () {
            },
            function () {
            });
    }

    function entityAdded() {
        reloadEntities();
    }

    function updateEntities(reloadDetails, initialEntityId) {
        var result = $filter('orderBy')(vm.allEntities, vm.query.order);

        if (initialEntityId) {
            var initialEntityResult = $filter('filter')(result, {id: {id: initialEntityId.id} }, true);
            if (initialEntityResult && initialEntityResult.length) {
                var initialEntityIndex = result.indexOf(initialEntityResult[0]);
                if (initialEntityIndex > -1) {
                    var targetPage = Math.floor(initialEntityIndex / vm.query.limit) + 1;
                    vm.query.page = targetPage;
                }
            }
        }

        if (vm.query.search != null) {
            result = $filter('filter')(result, {$: vm.query.search});
        }

        if (vm.displayPagination) {
            if (vm.serverPagedData) {
                vm.entities = result;
            } else {
                var startIndex = vm.query.limit * (vm.query.page - 1);
                vm.entities = result.slice(startIndex, startIndex + vm.query.limit);
                vm.entitiesCount = result.length;
            }
        } else {
            vm.entities = result;
        }
        if (reloadDetails) {
            $scope.$broadcast('reloadEntityDetails');
        }
        if (initialEntityId) {
            openEntityDetails(initialEntityId);
        }
        if (vm.entityTableConfiguration.entityType == types.entityType.gateway
            || vm.entityTableConfiguration.entityType == types.entityType.device) {
            vm.entityTableConfiguration.unsubscribeAllEntities($scope);
            vm.entityTableConfiguration.subscribeEntities($scope, vm.entities);
        }
    }

    function cellStyle(entity, column) {
        var style;
        var value = entity[column.key];
        if (column.cellStyleFunction) {
            try {
                style = column.cellStyleFunction(value, entity, $filter);
            } catch (e) {
                //
            }
        }
        return style || {};
    }

    function cellContent(entity, column) {
        var content;
        var value = entity[column.key];
        if (column.cellContentFunction) {
            var strContent = '';
            if (angular.isDefined(value)) {
                strContent = '' + value;
            }
            content = strContent;
            try {
                content = column.cellContentFunction(value, entity, $filter);
            } catch (e) {
                content = strContent;
            }
        } else {
            content = defaultContent(column, value);
        }
        return content;
    }

    function defaultContent(column, value) {
        if (angular.isDefined(value)) {
            var columnField = column;
            if (types.entityTable.entityField[column.key]) {
                columnField = types.entityTable.entityField[column.key];
            }
            if (columnField.time) {
                return $filter('date')(value, 'yyyy-MM-dd HH:mm:ss');
            } else if (columnField.boolean) {
                var checkboxClass = value ? 'md-checked' : '';
                return $sce.trustAsHtml(`<md-checkbox class="${checkboxClass}" disabled><div class="md-icon"></div></md-checkbox>`);
            } else {
                return value;
            }
        } else {
            return '';
        }
    }

    function onEntityUpdated(entity) {
        var result = $filter('filter')(vm.allEntities, { id: { id: entity.id.id }});
        if (result && result.length) {
            var prevEntity = result[0];
            var index = vm.allEntities.indexOf(prevEntity);
            if (index > -1) {
                vm.allEntities[index] = entity;
            }
            index = vm.entities.indexOf(prevEntity);
            if (index > -1) {
                vm.entities[index] = entity;
            }
        }
    }

    function deleteEntity($event, entity) {
        if ($event) {
            $event.stopPropagation();
        }
        var confirm = $mdDialog.confirm()
            .targetEvent($event)
            .title(vm.entityTableConfiguration.deleteEntityTitle(entity))
            .htmlContent(vm.entityTableConfiguration.deleteEntityContent(entity))
            .ariaLabel($translate.instant('entity-table.delete-entity'))
            .cancel($translate.instant('action.no'))
            .ok($translate.instant('action.yes'));
        $mdDialog.show(confirm).then(function () {
                vm.entityTableConfiguration.deleteEntity(entity.id.id).then(function success() {
                    reloadEntities();
                });
            },
            function () {
            });

    }

    function deleteEntities($event, entities) {
        var confirm = $mdDialog.confirm()
            .targetEvent($event)
            .title(vm.entityTableConfiguration.deleteEntitiesTitle(entities.length))
            .htmlContent(vm.entityTableConfiguration.deleteEntitiesContent(entities.length))
            .ariaLabel($translate.instant('entity-table.delete-entities'))
            .cancel($translate.instant('action.no'))
            .ok($translate.instant('action.yes'));
        $mdDialog.show(confirm).then(function () {
                var tasks = [];
                entities.forEach((entity) => {
                    if (vm.entityTableConfiguration.deleteEnabled(entity)) {
                        tasks.push(vm.entityTableConfiguration.deleteEntity(entity.id.id));
                    }
                });
                $q.all(tasks).then(function () {
                    reloadEntities();
                });
            },
            function () {}
        );
    }

}

/*@ngInject*/
export function AddEntityController($scope, $mdDialog, types, entityTableConfiguration) {

    var vm = this;

    vm.$onInit = function () {
        vm.entityTableConfiguration = entityTableConfiguration;
        vm.entityType = vm.entityTableConfiguration.entityType;
        vm.entity = {};
        vm.translations = types.entityTypeTranslations[vm.entityType];

        vm.add = add;
        vm.cancel = cancel;
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        $scope.$broadcast('form-submit');
        if ($scope.theForm.$valid) {
            vm.entityTableConfiguration.saveEntity(vm.entity).then(function success(entity) {
                vm.entity = entity;
                $scope.theForm.$setPristine();
                $mdDialog.hide();
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/table/entity-table.controller.js